<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    base-modal( :show='modal.coupon' )
      coupon-form( :user='user' :account='account' :biz='biz' @close='modal.coupon = false' )
    
    base-modal( :show='!!editable' )
      coupon-edit-form( :editable='editable' :user='user' :account='account' :biz='biz' @close='editable = false' )

    #marketing.view
      header
        bf-wrapper
          h2.mesg {{ $t('Marketing') }}
          .items
            span.box
              p {{$t("It is important to display your page URL, the page will help your customer to register as your member and make reservation with you")}}: 
              .url
                router-link(:to='{ name: "merchant", params: {id: biz.id}}') https://app.bluefaucet.com/m/{{biz.id}} 
                span.copy-icon.actionable( v-clipboard='`https://app.bluefaucet.com/m/${biz.id}`' @click='copymsg')
                  img(src='/ui/copy.svg' width='20')
            span.box
              p {{$t("You may display your dedicated QR code for your customer to scan and visit your page")}}
              p.url
                qr-code.qr-code( :value="`https://app.bluefaucet.com/m/${biz.id}`" :options="{ width: 192 }" )

      bf-wrapper
        H4.mesg {{$t("Basic Coupons")}}
        p {{$t("These are 3 basic coupons you can enable to use")}}
      bf-wrapper.basic-coupon
        span.box
          form
            input.checkbox( ref='rsv' type='checkbox' @change='activate("rsv")' v-model='rewards.rsv.active' )
            label.title {{ $t('Use BlueFaucet to Make Reservation') }}
            fieldset
              label {{ $t('Discount offered') }} 
              input.med( type='text' v-model='rewards.rsv.discount' @change='activate("rsv")' )
        span.box
          form
            input.checkbox( ref='ref' type='checkbox' @change='activate("ref")' v-model='rewards.ref.active' )
            label.title {{ $t('Refer a Friend') }} 
            fieldset
              label {{ $t('Discount offered') }} 
              input.med( type='text' v-model='rewards.ref.discount' @change='activate("ref")' )
        span.box
          form
            input.checkbox( ref='first' type='checkbox' @change='activate("first")' v-model='rewards.first.active' )
            label.title {{ $t('First Time Visit') }} 
            fieldset
              label {{ $t('Discount offered') }} 
              input.med( type='text' v-model='rewards.first.discount' @change='activate("first")' )
      section#coupons
        bf-wrapper.custom
          h4 {{ $t('My Coupons') }}:
          .table-container
            table
              tr
                th {{ $t('Name') }}
                th {{ $t('Status') }}
                th
                  bf-button.auto( @click.native='modal.coupon = true' )
                    template(v-slot:text) {{ $t('ADD') }}
              tr( v-for='item in coupons' )
                td {{ item.title }}
                td {{ item.status }}
                td
                  span.icon.actionable( @click='edt(item)' )
                    edit-icon
                  span.icon.actionable( @click='del(item)' )
                    delete-icon
</template>

<script>
  import { db } from '@/main'
  import { View } from '@/mixins/view'
  import QrCode from '@chenfengyuan/vue-qrcode'
  import BaseModal from '@/components/modals/base'
  import CouponForm from '@/components/forms/coupon'
  import CouponEditForm from '@/components/forms/coupon-edit'

  export default {
    name: 'marketing.view',

    mixins: [View],

    components: {
      QrCode,
      BaseModal,
      CouponForm,
      CouponEditForm
    },

    data() {
      return {
        modal: { coupon: false, edit: false },
        coupons: [],
        editable: false,
        rewards: { 
          rsv: { active: false, discount: '' },
          ref: { active: false, discount: '' },
          first: { active: false, discount: '' }
        },
        discounts: {}
      }
    },

    firestore() {
      if ( this.user ) return {
        coupons: db.collection( 'coupons' ).where( 'uid', '==', this.user.uid )
      }
    },

    watch: {
      user(curr, prev) {
        if ( curr ) this.$binding( 'coupons', db.collection( 'coupons' ).where( 'uid', '==', curr.uid ) )
      },

      account( curr, prev) {
        if ( curr.id ) {
          this.rewards = curr.rewards || { 
            rsv: { active: false, discount: '' },
            ref: { active: false, discount: '' },
            first: { active: false, discount: '' }
          }
          console.log(this.rewards)
          this.discounts = this.rewards.discounts || []
        }
      }
    },

    methods: {
      copymsg(){
        alert(this.$t(this.$t('URL copied to clipboard')))
      },

      activate( type ) {
        if ( !this.rewards[type].discount ) {
          if( this.rewards[type].active ) return this.$refs[type].click()
        }
        db.collection( 'accounts' ).doc( this.account.id ).update({ rewards: this.rewards })
      },

      del( item ) {
        db.collection( 'coupons' ).doc( item.id ).delete()
      },

      edt(item) {
        this.editable = item
      }
    },

    created() {
      if ( this.account.id ) {
        this.rewards = this.account.rewards || { 
          rsv: { active: false, discount: '5% off' },
          ref: { active: false, discount: '5% off' },
          first: { active: false, discount: '5% off' }
        }
        this.discounts = this.rewards.discounts || []
      }
    }
  }

</script>
<style scoped lang='stylus'>
  input
    border 1px solid rgba( 0 0 0 .1 )
    border-radius 5px

  #marketing
    //

  .mesg
    margin-bottom 20px
    
  header
    padding 0px 0
    box-shadow var(--shadow-box)
    .url
      text-align center
      margin-top 10px
      color blue
      font-weight bold
      font-size 1.2em
    .qr-code
      text-align center
  .items
    display grid
    grid-template-columns  1fr 1fr
    grid-gap 20px
    @media( max-width: 560px)
      grid-template-columns 1fr
  .basic-coupon
    display grid
    grid-template-columns  1fr 1fr 1fr 
    grid-gap 20px
    @media( max-width: 560px )
      grid-template-columns 1fr
  .box
    background white
    padding 10px
    border 1px solid rgba(0 0 0 .1)
    border-radius 5px
    font-size 1.1em
    &:hover, &:focus
      background rgb( 255 255 255)
      box-shadow var(--shadow-box)
    input.med
      padding 5px
      margin-top 5px
      background white
    input.checkbox 
      transform scale(1.5)
      margin-right 10px
    .title
      font-size 1.15em
      font-weight bold
    
  section
    padding 0px 0
    &:nth-child(odd)
      background rgb( 240 240 240 )
    > .bf-wrapper form
      display grid
      grid-template-columns 32px 1fr 128px
      .checkbox input
        margin 0
        margin-top 3px
      .fields > label
        font-weight bold
      .update-btn
        display flex
        align-items flex-end
      fieldset
        margin 12px 0
      input
        margin 0 16px
        padding 4px 8px
        &.med
          width 65% //296px
        &.long
          width 75% //360px
        &.short
          width 64px
      @media( max-width: 640px )
        grid-template-columns 32px 1fr
        input.med, input.long
          width auto
        input.med
          width 80px
        .update-btn
          grid-column 1 / -1
          justify-content center
          padding-top 16px
  section#coupons
    .custom
      background orange
      color white
      border 1px solid rgba(0 0 0 .25)
      border-radius 5px
    .table-container
      border-radius 7px
      border 1px solid rgba( 0 0 0 .25 )
      overflow hidden
      margin-top 10px
    table
      width 100%
      color black
      background white

      tr:nth-child(even)
        background rgb( 240 240 240 )
      th
        font-weight bold
      
      th:nth-child(2), td:nth-child(2)
        text-align center
      th, td
        padding 12px 16px
        text-align center
        &:first-child
          text-align left
        &:last-child
          text-align right
        .icon
          font-size 1.5em
          &:first-child
            margin-right 28px
</style>
